export function QueryString(value: string): string | null {
  if (typeof window !== 'undefined') {
    const queryParams = new URLSearchParams(window.location.search);
    return queryParams.get(value);
  }
  return null;
}